// Pages an announcement button may open — always inside the customer's own workspace.
export const ANNOUNCEMENT_CTA_PATHS = [
  { path: "/campaigns", label: "Campaigns" },
  { path: "/campaigns/onboarding", label: "New Campaign" },
  { path: "/crm", label: "CRM" },
  { path: "/inbox", label: "Inbox" },
  { path: "/profiles", label: "Profiles" },
  { path: "/linkedin-accounts", label: "LinkedIn Accounts" },
] as const;

export function isAllowedCtaPath(path: string | null | undefined): boolean {
  return !!path && ANNOUNCEMENT_CTA_PATHS.some((p) => p.path === path);
}

export type AnnouncementStatus = "draft" | "live" | "ended" | "scheduled";

export function announcementStatus(a: { status: string; starts_at: string | null; ends_at: string | null }, now = new Date()): AnnouncementStatus {
  if (a.status !== "live") return "draft";
  if (a.ends_at && new Date(a.ends_at) <= now) return "ended";
  if (a.starts_at && new Date(a.starts_at) > now) return "scheduled";
  return "live";
}

// Dashboard pages where the pop-up may appear (never inside setup wizards).
export function canShowAnnouncementOn(pathname: string): boolean {
  if (pathname.startsWith("/campaigns/onboarding")) return false;
  if (pathname === "/" || pathname === "/dashboard") return true;
  return ["/campaigns", "/crm", "/inbox", "/profiles", "/linkedin-accounts"].some(
    (p) => pathname === p || pathname.startsWith(p + "/"),
  );
}
